import { TOP_SIDE, BOTTOM_SIDE, COMBINED, TWO_SIDES } from "../data/StencilsConstants"

export const getStencilsTitle = (stencilsSide) => {
  switch (stencilsSide) {
    case TOP_SIDE:
      return 'TOP';
    case BOTTOM_SIDE:
      return 'BOTTOM';
    case COMBINED:
      return 'COMBINED';
    case TWO_SIDES:
      return 'TOP & BOTTOM';
    default:
      return '';
  }
}